    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col">
                <h5 class="blue"><i class="fas fa-plus"></i>&nbsp;Crear carga</h5>
            </div>
        </div>
        <hr>
        <form #formNuevaCarga="ngForm" (ngSubmit)="formSubmit(formNuevaCarga)" novalidate="" >
            <div class="container-fuid" style="height: 460px; overflow-y: auto; padding-right: 20px; overflow-x: hidden;">
                <div class="row mt-3" style="margin-right: 0px; margin-left: 0px;">
                    <div    class="col col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Estación&nbsp;<i class="fas fa-map-marker-alt"></i></label>
                            <br> 
                            <p-dropdown [disabled]="!isAdmin"  name="slcEstaciones" (onChange)="updateListEquipos($event)" #slcEstaciones="ngModel" [options]="estaciones" 
                                [filter]="true" filterBy="label" [style]="{'width':'100%'}" placeholder="Selecciona una estación" 
                                [(ngModel)]="cargaRQ.idEstacion" styleClass="custom-input"
                                optionValue="value" optionLabel="label" [required]="true">
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Equipo&nbsp; <i class="fas fa-truck"></i></label>
                            <br>
                            <p-dropdown name="slcEquipos" [disabled]="equiposValid" #slcEquipos="ngModel" (onChange)="updateInfoEquipo($event)" [options]="equipos" 
                            [filter]="true" filterBy="label" [style]="{'width':'100%'}" 
                            [placeholder]="!equiposValid ? ' Selecciona un equipo' : 'Sin equipos'" [required]="true"
                            styleClass="custom-input" [(ngModel)]="cargaRQ.idEquipo" optionLabel="label" optionValue="value">
                            </p-dropdown>
                        </div>
                    </div>
                </div>
                <div class="row mt-3" style="margin-right: 0px; margin-left: 0px;">
                    <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Tipo de combustible:</label>
                            <br>
                            <div class="input-group">
                                <input type="text" autocomplete="off" readonly placeholder="Magna/Diesel/Turbosina" 
                                name="txtCombustible" #txtCombustible="ngModel" class="form-control form-control-sm custom-input-group" 
                                [(ngModel)]="cargaRQ.idCombustible" required>
                                <span class="input-group-text custom-input-group-text" ><i class="fas fa-oil-can"></i></span>
                            </div>        
                        </div>
                    </div>
                    <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Almac&eacute;n:</label>
                            <br>
                            <div class="input-group">
                                <input type="text" autocomplete="off" readonly placeholder="Número de almacen" name="txtAlmacen" #txtAlmacen="ngModel" 
                                class="form-control form-control-sm custom-input-group"  [(ngModel)]="cargaRQ.almacen" required>
                                <span class="input-group-text custom-input-group-text" ><i class="fas fa-gas-pump"></i></span>
                            </div>        
                        </div>
                    </div>
                </div> 
                <div class="row mt-3" style="margin-right: 0px; margin-left: 0px;">
                    <div    class="col col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Operador:</label>
                            <br> 
                            <p-dropdown  name="slcOperadores"  #slcOperadores="ngModel" [options]="operadores" [disabled]="operadoresValid"
                                [filter]="true" filterBy="label" [style]="{'width':'100%'}"  [(ngModel)]="cargaRQ.idOperador" 
                                styleClass="custom-input" placeholder="Seleccionar un Operador"  optionValue="value" optionLabel="label" [required]="true"
                                [placeholder]="!operadoresValid ? 'Selecciona un operador' : 'Sin personal'" >
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Despachador:</label>
                            <br>
                            <p-dropdown name="slcDespachadores" #slcDespachadores="ngModel" [disabled]="despachadoresValid" [options]="despachadores" [filter]="true" 
                                filterBy="label" [style]="{'width':'100%'}" [required]="true" styleClass="custom-input"
                                [(ngModel)]="cargaRQ.idDespachador" optionLabel="label" optionValue="value"
                                [placeholder]="!despachadoresValid ? 'Selecciona un despachador' : 'Sin personal'">
                        </p-dropdown>
                        </div>
                    </div>
                </div>
                <div class="row mt-3" style="margin-right: 0px; margin-left: 0px;">
                    <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Litros:</label>
                            <br>
                            <div class="input-group">
                                <input type="number" autocomplete="off"  step="0.2" placeholder="Litros a cargar" 
                                name="txtLitros" #txtLitros="ngModel" class="form-control form-control-sm custom-input-group" 
                                pattern="^(?:[1-9]|(?:[1-9][0-9])|(?:[1-4][0-9][0-9])|(?:499))(\.[0-9]{1,2})?$"   [(ngModel)]="cargaRQ.litrosCargados" required>
                                <span class="input-group-text custom-input-group-text" ><i class="fas fa-tint"></i></span>
                            </div>        
                            <small> Formato 0.00 (1 a 499.99) </small>
                        </div>
                    </div>

                    <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Hor&oacute;metro:</label>
                            <br>
                            <div class="input-group">
                                <input type="number" autocomplete="off"  step="0.2"  placeholder="Número de horómetro"
                                name="txtHorometro" #txtHorometro="ngModel" class="form-control form-control-sm custom-input-group" 
                                pattern="^\d+(\.\d{1,2})?"   [(ngModel)]="cargaRQ.horometro" required>
                                <span class="input-group-text custom-input-group-text" ><i class="fas fa-tachometer-alt"></i></span>
                            </div>        
                            <small>   Formato 0.00 </small>
                        </div>
                    </div>
                </div> 
                <div class="row mt-3" style="margin-right: 0px; margin-left: 0px;">
                    <div class="form-group">
                        <label>Foto Hor&oacute;metro&nbsp;</label><i class="fas fa-camera"></i>
                        <br>
                        <input #inputFile type="file" class="form-control form-control-sm custom-input" (change)="changeListener($event)" accept=".png, .jpg, .jpeg" required />
                    </div>

                </div>
            </div>
            <div class="row mt-4">
                <div class="col text-end">
                    <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                                <i class="fa fa-arrow-left"></i>
                                Regresar
                    </button>
                    <button type="submit" [disabled]="!formNuevaCarga.form.valid" class="side-space btn btn-sm rounded-button btn-success">
                        Aceptar
                        <i class="fa fa-check"></i>
                    </button>
                </div>
            </div>
        </form>
    </div>